import React from 'react';
import Card from '../components/Card';
import StatusBadge from '../components/StatusBadge';
import type { Transaction } from '../types';

const withdrawals: Transaction[] = [
    {
        id: '1',
        amount: 300,
        status: 'completed',
        date: '2024-03-10',
        commission: 5,
        destinationAccount: 'PayPal - user@example.com'
    },
    {
        id: '2',
        amount: 500,
        status: 'pending',
        date: '2024-03-09',
        commission: 7.50,
        destinationAccount: 'Airtm - user123'
    }
];

export default function Withdrawals() {
    return (
        <div className="space-y-6">
            <h1 className="text-2xl font-bold text-gray-900">Withdrawals</h1>

            <Card>
                <div className="overflow-x-auto">
                    <table className="w-full">
                        <thead>
                        <tr className="text-left border-b border-gray-200">
                            <th className="pb-3 font-semibold text-gray-600">Date</th>
                            <th className="pb-3 font-semibold text-gray-600">Amount</th>
                            <th className="pb-3 font-semibold text-gray-600">Commission</th>
                            <th className="pb-3 font-semibold text-gray-600">Destination</th>
                            <th className="pb-3 font-semibold text-gray-600">Status</th>
                        </tr>
                        </thead>
                        <tbody>
                        {withdrawals.map((withdrawal) => (
                            <tr key={withdrawal.id} className="border-b border-gray-100">
                                <td className="py-4 text-gray-600">{withdrawal.date}</td>
                                <td className="py-4 text-gray-900 font-medium">
                                    ${withdrawal.amount.toFixed(2)}
                                </td>
                                <td className="py-4 text-gray-600">
                                    ${withdrawal.commission?.toFixed(2)}
                                </td>
                                <td className="py-4 text-gray-900">{withdrawal.destinationAccount}</td>
                                <td className="py-4">
                                    <StatusBadge status={withdrawal.status} />
                                </td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                </div>
            </Card>
        </div>
    );
}